/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./OrderMessage.vue?vue&type=template&id=5bff40ea&scoped=true&lang=html&"
import script from "./OrderMessage.vue?vue&type=script&lang=js&"
export * from "./OrderMessage.vue?vue&type=script&lang=js&"
import style0 from "./OrderMessage.vue?vue&type=style&index=0&id=5bff40ea&lang=less&scoped=true&"
import style1 from "./OrderMessage.vue?vue&type=style&index=1&id=5bff40ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff40ea",
  null
  
)

export default component.exports